import React,{useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select, Row, Col, Checkbox } from "antd";
import {
  getNielsenCustomerFilters,
  setNielsenCustDataFilters,
  setNielsenCustFilters,
  setNielsenWeeklyCustFilters,
  setnielsencolumnSelectionCheckbox,
  setincludeAllCheckboxNielsen,
} from "../../slicers/nielsenfilters.slicer";

const CustFiltersSection = ({  applyErrorMarket, applyErrorCd }) => {
  const {
    cust_filters_nielsen,
    customerFiltersWeekly,
    customer_retail,
    customer_channel,
    customer_market,
    customer_desc,
    kpis,
    nielsen_columnSelectionCheckbox,
    nielsentimeframeCheckbox,
    timeHorizonRadioNielsen,
    time_frames
  } = useSelector((state) => state.nielsenfilters);
  const [warningShown,setWarningShown]= useState(false)
  const dispatch = useDispatch();
  const includeAllLevels = [
    "customer_id__market",
    "customer_id__customer_desc",
    "customer_id__channel",
    "customer_id__retailer",
    "product_id__animal_type",
    "product_id__portfolio",
    "product_id__technology",
    "product_id__manufacturer",
    "product_id__brand",
    "product_id__local_manufacturer",
    "product_id__local_brand",
    "product_id__sub_brand",
    "product_id__pack_format",
    "product_id__pack_size",
    "product_id__number_in_pack",
    "product_id__pack_type",
    "product_id__ppg",
    "product_id__flavour",
    "product_id__product_size",
    "product_id__product_description",
    "product_id__product_long_description",
    "product_id__ean_code",
    "product_id__Growth_Drivers",
  ];
  
  //Color coding to markets 
  const colors = ['lightblue', 'aquamarine', 'bisque', 'lightyellow'];
  var colors_dict={"DE":'lightblue',"FR":'aquamarine','PL':'bisque','UK':'lightyellow'}

  //function for updating the customer filters, kpis after selecting values from dropdowns
  const onCustSelection = (key, value) => {
    let newCustFilters = {
      ...cust_filters_nielsen,
      [key]: value,
    };
    dispatch(setNielsenCustFilters(newCustFilters));
    dispatch(setNielsenCustDataFilters(newCustFilters));
    const shouldShowWarning= value.some(val => val==='TDP' || val==='N_Dist' || val === 'W_Dist');
    setWarningShown(shouldShowWarning);
  };
  //function for updating single select market filter
  const onMarketSingleSelect = (val) => {
    let newMktFiltersSelected = {
      ...customerFiltersWeekly,
      ["customer_market"]: [val],
    };
    dispatch(setNielsenCustFilters(newMktFiltersSelected));
    dispatch(setNielsenWeeklyCustFilters(newMktFiltersSelected));
    dispatch(setNielsenCustDataFilters(newMktFiltersSelected));
  };
  //functions for handling dropdowns after clearing the selected options
  const handleOnClear = (key, value) => {
    let newFilters = {
      ...cust_filters_nielsen,
      [key]: value,
    };
    dispatch(setNielsenCustFilters(newFilters));
    dispatch(setNielsenCustDataFilters(newFilters));
    dispatch(getNielsenCustomerFilters(newFilters));
  };
  const handleClearSingleMarket = () => {
    let newMktFilterSelected = {
      customer_market: [],
    };
    dispatch(setNielsenCustFilters(newMktFilterSelected));
    dispatch(setNielsenWeeklyCustFilters(newMktFilterSelected));
    dispatch(setNielsenCustDataFilters(newMktFilterSelected));
    dispatch(getNielsenCustomerFilters(newMktFilterSelected));
  };
  //function for maintaining selected columns in the nielsencolumnSelectionCheckbox array
  const columns_Selection = () => (e) => {
    if (e.target.checked) {
      let value = [...nielsen_columnSelectionCheckbox];
      value.push(e.target.value);
      dispatch(setnielsencolumnSelectionCheckbox(value)) &&
      nielsen_columnSelectionCheckbox.length === includeAllLevels.length - 1
        ? dispatch(setincludeAllCheckboxNielsen(["include_all_levels"]))
        : dispatch(setincludeAllCheckboxNielsen([""]));
    } else {
      let value = [...nielsen_columnSelectionCheckbox];
      value = value.filter((val) => val !== e.target.value);
      dispatch(setnielsencolumnSelectionCheckbox(value));
      dispatch(setincludeAllCheckboxNielsen([""]));
    }
  };

  return (
    <>
      <span className="solid-background"></span>
      <h5 style={{ marginTop: "-20px", marginLeft: "10px" }}>
        Market and Customer Details
      </h5>
      <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
        <Col md={8} className="dropdown-card" style={{ marginTop: 10 }}>
          <Checkbox
            value={"customer_id__market"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("customer_id__market")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Market</label>}
          </Checkbox>
          {timeHorizonRadioNielsen !== "weekly" ? (
            <>
            <Select
              defaultActiveFirstOption={true}
              dropdownMatchSelectWidth={false}
              value={cust_filters_nielsen.customer_market}
              onChange={(val) => onCustSelection("customer_market", val)}
              onBlur={() =>
                dispatch(getNielsenCustomerFilters(cust_filters_nielsen))
              }
              onClear={() => handleOnClear("customer_market", [])}
              placeholder="All"
              mode="multiple"
              maxTagCount="responsive"
              placement="bottomLeft"
              allowClear
              bordered={true}
              style={{ width: "100%", marginTop: "10px" }}
            >
              
              {customer_market.map((val,i) => (
                <Select.Option value={val}  style={{backgroundColor: colors[i]}}>{val}</Select.Option>
              ))}
            </Select>

            </>
          ) : (
            <>
              <Select
                dropdownMatchSelectWidth={false}
                value={customerFiltersWeekly.customer_market}
                onChange={(val) => {
                  if (val) {
                    onMarketSingleSelect(val);
                  }
                }}
                onBlur={() =>
                  dispatch(getNielsenCustomerFilters(customerFiltersWeekly))
                }
                onClear={handleClearSingleMarket}
                placeholder="Select Market"
                mode="single"
                maxTagCount="responsive"
                placement="bottomLeft"
                allowClear
                bordered={true}
                style={{ width: "100%", marginTop: "10px" }}
              >
                {customer_market?.map((val,i) => {
                  if (val !== "ALL")
                  return <Select.Option value={val}  style={{backgroundColor: colors[i]}}>{val}</Select.Option>
                })}
              </Select>
              <Row style={{ marginTop: 10 }}>
                {applyErrorMarket ? (
                  <p style={{ color: "red" ,width:"150%"}}>
                    Market selection is mandatory for Dynamic Weekly
                  </p>
                ) : (
                  ""
                )}
              </Row>
            </>
          )}
        </Col>
           
        <Col md={8} className="dropdown-card" style={{ marginTop: 10 }}>
          <Checkbox
            value={"customer_id__channel"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("customer_id__channel")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Channel</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={cust_filters_nielsen.customer_channel}
            onChange={(val) => onCustSelection("customer_channel", val)}
            onBlur={() =>
              dispatch(getNielsenCustomerFilters(cust_filters_nielsen))
            }
            onClear={() => handleOnClear("customer_channel", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {customer_channel?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>

        <Col md={8} className="dropdown-card" style={{ marginTop: 10 }}>
          <Checkbox
            value={"customer_id__retailer"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes("customer_id__retailer")
            }
            onChange={columns_Selection()}
            style={{ marginTop: "5px" }}
          >
            {<label className="label-block-nielsen">Retailer</label>}
          </Checkbox>
          <Select
            dropdownMatchSelectWidth={false}
            placeholder="All"
            mode="multiple"
            value={cust_filters_nielsen.customer_retail}
            onChange={(val) => onCustSelection("customer_retail", val)}
            onBlur={() =>
              dispatch(getNielsenCustomerFilters(cust_filters_nielsen))
            }
            onClear={() => handleOnClear("customer_retail", [])}
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
            {customer_retail?.map((val) => (
              <Select.Option value={val}>{val}</Select.Option>
            ))}
          </Select>
        </Col>
        {/* { timeHorizonRadioNielsen !== "weekly" 
        && !!nielsentimeframeCheckbox 
        && nielsentimeframeCheckbox.includes("2ya")
        && cust_filters_nielsen.customer_market.map((i)=>(
              i==='FR'? 
              <Col md={24} className="dropdown-card" style={{ marginTop: 6 }}>
                <Row style={{ marginTop: 10 }}>
                  <p style={{ color: "orange", fontSize:'11px' }}>
                    ⚠️ Please note that full 2YA data is not available for <b>FR</b> market
                  </p>
                </Row>
               </Col>
               :''
            ))} */}
        <Col md={12} className="dropdown-card" style={{ marginTop: 6 }}>
          <Checkbox
            value={"customer_id__customer_desc"}
            checked={
              !!nielsen_columnSelectionCheckbox &&
              nielsen_columnSelectionCheckbox.includes(
                "customer_id__customer_desc"
              )
            }
            
            style={{ marginTop: "5px" }}
          >
            {
              <label className="label-block-nielsen">
                Customer Description (Must Select)
              </label>
            }
          </Checkbox>
          <Select
             dropdownMatchSelectWidth={false}
             placeholder="Select Customer Description"
             value={cust_filters_nielsen.customer_desc}
             //onChange={(val) => onCustSelection("customer_desc", val)}
             onChange={(val) => {
               
               if (val) {
                 onCustSelection("customer_desc", val);
               }
             }}
            onBlur={() =>
              dispatch(getNielsenCustomerFilters(cust_filters_nielsen))
            }
            onClear={() => handleOnClear("customer_desc", [])}
            mode="multiple"
            allowClear
            bordered={true}
            maxTagCount="responsive"
            style={{ width: "100%", marginTop: "10px" }}
          >
             {customer_desc?.map((val) => (
               <Select.Option value={val.customer_desc} style={{backgroundColor: colors_dict[val.market]}}>{val.customer_desc}</Select.Option>
             ))}
          </Select>
          <Row style={{ marginTop: 10, width: "150%"}}>
                {applyErrorCd ? (
                  <p style={{ color: "red" }}>
                    Select at least one Customer Description for each selected market
                  </p>
                ) : ( 
                  ""
                )}
              </Row>
        </Col>
        <Col md={24} style={{ marginTop: 32 }}>
          <span className="solid-background"></span>
          <h5 style={{ marginTop: "-20px", marginLeft: "10px" }}>KPI</h5>
          <Row gutter={10} style={{ marginTop: 15 }}>
            <Col md={8} className="dropdown-card">
              <label className="label-block-nielsen">KPI</label>
              <Select
                dropdownMatchSelectWidth={false}
                placeholder="All"
                mode="multiple"
                value={cust_filters_nielsen.kpis}
                onChange={(val) => onCustSelection("kpis", val)}
                allowClear
                maxTagCount="responsive"
                style={{ width: "100%" }}
              >
                {kpis?.map((val) => (
                  <Select.Option value={val}>{val}</Select.Option>
                ))}
              </Select>
            </Col>
            
            { timeHorizonRadioNielsen && !!nielsentimeframeCheckbox  && warningShown &&
             (
              <Col md={24} className="dropdown-card" style={{ marginTop: 6 }}>
                <Row style={{ marginTop: 10 }}>
                  {
                
                  <p style={{ color: "orange", fontSize:'11px' }}>
                    ⚠️Please don't use TDP/ N_Dist/ W_Dist KPIs for now. These KPIs verification is in progress.
                  </p>
                  }
                </Row>
               </Col>
             )
             };
            <Col md={12}></Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default CustFiltersSection;
